var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#1D4469",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1764 6.67139L5.67349 12.1797C5.64581 12.2075 5.62582 12.2426 5.6163 12.2803L5.00635 14.7307C4.98811 14.8044 5.00976 14.8829 5.06355 14.9367C5.10424 14.9775 5.15969 15 5.21641 15C5.23378 15 5.25155 14.9979 5.26885 14.9935L7.71703 14.3829C7.75519 14.3734 7.78986 14.3535 7.81754 14.3257L13.3209 8.81786L11.1764 6.67139Z",
    fill: "#1D4469"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6829 5.9203L14.0703 5.30718C13.6609 4.89741 12.9473 4.8978 12.5384 5.30718L11.7881 6.05822L13.9325 8.2046L14.6829 7.45357C14.8874 7.24896 15 6.97662 15 6.68697C15 6.39733 14.8874 6.12499 14.6829 5.9203Z",
    fill: "#1D4469"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleEdit);
export default __webpack_public_path__ + "static/media/CircleEdit.1ee37b4e89e5d0a4096a70c1c093a1c4.svg";
export { ForwardRef as ReactComponent };